import { render, staticRenderFns } from "./CourseUsers.vue?vue&type=template&id=5e4f653c&scoped=true"
import script from "./CourseUsers.vue?vue&type=script&lang=js"
export * from "./CourseUsers.vue?vue&type=script&lang=js"
import style0 from "./CourseUsers.vue?vue&type=style&index=0&id=5e4f653c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4f653c",
  null
  
)

export default component.exports